import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../utils/messages';

export default function IndietroButton(props) {
  const theme = useTheme();
  const history = useHistory();

  return (
    <Button
      type="button"
      onClick={() => {
        if (props.alert === true) {
          const confirmed = window.confirm(UNSAVED_CHANGES_LEAVE_MESSAGE);
          if (!confirmed) {
            return;
          }
          // we can skip the navigation guard by calling the onConfirmedNavigate function
          // this avoids showing the confirmation dialog a second time
          props.onConfirmedNavigate?.();
        }
        history.goBack();
      }}
      variant="contained"
      className="float-right"
      disabled={props.isDisabled}
      style={{
        color: props.disabled
          ? theme.palette.text.disabled
          : theme.palette.text.main,
        margin: '10px',
        backgroundColor: props.isDisabled
          ? theme.palette.disabled.main
          : theme.palette.secondary.main,
      }}
    >
      {props.label === null || props.label === undefined
        ? 'Indietro'
        : props.label}
    </Button>
  );
}

IndietroButton.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  alert: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onConfirmedNavigate: PropTypes.func,
};
